import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    Setting,
    TibboDataType,
    ValidationMessage,
    ValidationMessageType,
    SettingType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class Tibbit43Node extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 43';
        this.id = 'node_tibbit_43';
        this.linkedFeature = 'tibbit_43';

        this.inputs = [];
        this.outputs = [];
        for (let i = 0; i < 4; i++) {
            this.inputs.push({
                name: `Read Channel ${(i + 1)}`,
                portId: `tibbit_43_read_channel_${(i + 1)}`,
                params: [],
            });
            this.outputs.push({
                name: `Channel ${(i + 1)} Data`,
                portId: `channel${(i + 1)}Data`,
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'channel',
                        dataType: TibboDataType.BYTE,
                    },
                ],
            });
        }
    }

    validate(): Array<ValidationMessage> {
        let errors: Array<ValidationMessage> = [];
        const project: ProjectConfiguration = this.project;
        const tibbit = project.getFeature(this.getSettingValue('TIBBIT'));
        if (!tibbit) {
            return [
                {
                    message: 'Tibbit 43 not defined',
                    messageType: ValidationMessageType.ERROR,
                    featureId: this.getID(),
                    settingId: 'TIBBIT',
                },
            ];
        }
        const MODE = tibbit.getSettingValue('MODE');
        let links = project.getNodeLinks(this, 'tibbit_43_read_data_ascii');
        if (links.length > 0 && MODE === 'DATA_MODE') {
            errors = errors.concat({ message: '"Read ASCII" function not available in data mode', messageType: ValidationMessageType.ERROR });
        }
        links = project.getNodeLinks(this, 'tibbit_43_read_data_hex');
        if (links.length > 0 && MODE === 'DATA_MODE') {
            errors = errors.concat({ message: '"Read HEX" function not available in data mode', messageType: ValidationMessageType.ERROR });
        }
        links = project.getNodeLinks(this, 'tibbit43_data');
        if (links.length > 0 && MODE === 'DATA_MODE') {
            errors = errors.concat({ message: '"Data Available" function not available in data mode', messageType: ValidationMessageType.ERROR });
        }
        links = project.getNodeLinks(this, 'callback_tibbit_43_sampling_completed');
        // if (links.length > 0 && MODE === 'COMMAND_MODE') {
        //     errors = errors.concat({
        //         message: '"Sampling Complete" function not available in command mode',
        //         messageType: ValidationMessageType.ERROR
        //     });
        // }
        return errors;
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const tibbit = project.getFeature(this.getSettingValue('FEATURE'));
        if (!tibbit) {
            return blocks;
        }
        const tibbitName = tibbit.getSettingValue('NAME');
        const SOCKET = `S${tibbit.getSettingValue('SOCKET')}_TBT43`;
        const SAMPLING = tibbit.getSettingValue('SAMPLING');
        let format;
        switch (tibbit.getSettingValue('FORMAT_COMMAND')) {
            case 'DATA_ASCII':
                format = 'ascii';
                break;
            case 'DATA_HEX':
                format = 'hex';
                break;
            default:
                break;
        }

        let CHANNELS = SAMPLING === 'SAMPLING_DIFF' ? tibbit.getSettingValue('CHANNELS_DIFF') : tibbit.getSettingValue('CHANNELS_SINGLE');
        CHANNELS = CHANNELS.split(',').sort().join(',');
        let dataLocation = '';

        const dataAvailablefunctionName = `${tibbitName}_data_available`;

        for (let i = 1; i <= 4; i++) {
            let links = project.getNodeLinks(this, `channel${i}Data`);
            if (links.length > 0) {
                const link = links[0];
                dataLocation += `
    if channel = ${i} then
        '****${link.getSourceId()}****'
    end if
`;
            }

            links = project.getNodeLinks(this, `tibbit_43_read_channel_${i}`);
            if (links.length > 0) {
                const link = links[0];
                blocks.push({
                    location: link.getSourceId(),
                    blockType: BlockType.CODE,
                    template: `
    dim ${tibbitName}_channel_${i}_val as string = tibbit_43_get_data_${format}(${SOCKET},"${i}")
    ${dataAvailablefunctionName}(${tibbitName}_channel_${i}_val, ${i})`,
                });
            }
        }

        blocks.push({
            location: 'DEVICE_TBS',
            id: dataAvailablefunctionName,
            blockType: BlockType.LOCATION,
            template: `
sub ${dataAvailablefunctionName}(data as string, channel as byte)
    ${dataLocation}
end sub
                `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            id: `declare_${dataAvailablefunctionName}`,
            blockType: BlockType.CODE,
            template: `
    'Tibbit 43 data available callback for ${tibbitName}
    declare sub ${dataAvailablefunctionName}(data as string, channel as byte)`,
        });

        //     links = project.getNodeLinks(this, 'tibbit_43_read_channel_2');
        //     if (links.length > 0) {
        //         const link = links[0];
        //         blocks.push({
        //             location: link.getSourceId(),
        //             blockType: BlockType.CODE,
        //             template: `
        // dim ${tibbitName}_channel_1_val as string = tibbit_43_get_data_${format}(${SOCKET},"2")
        // ${dataAvailablefunctionName}(${tibbitName}_channel_2_val, 2)`,
        //         });
        //     }
        //     blocks.push({
        //         location: 'callback_tibbit_43_sampling_completed',
        //         blockType: BlockType.CODE,
        //         template: `
        // ${sampleCompleteLocation}

        // `,
        //     });
        return blocks;
    }
}
